module.exports = "mutation ($id: ID!) {\n  OpenhouseDelete(id: $id) {\n    id\n  }\n}\n"